/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData';
import {
    instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataFromJSON,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataFromJSONTyped,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataToJSON,
} from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData';

/**
 * @type FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData
 * 
 * @export
 */
export type FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData = FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData;

export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSON(json: any): FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData(json)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSON(json: any): any {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSONTyped(value?: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData(value)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataToJSON(value as FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData);
    }

    return {};
}

